import { message, Modal } from "antd";
import { openPicker as openCategoriesPicker } from "../components/CategoriesPickerTree";
import { IPageAddCallback, api } from "./index";
import { getPermissions } from "../permissions";
import context, { lang } from "../context";
import { getSpaceIdByRootId, moveTips } from "../util";
import events from "../context/events";
import { ActionFnEnum, ActionType } from "../types";
import { folderTypeEnum } from "../config/permissions.config";
import { getPageMenuLogId } from "./utils";
import { analysisLog } from "@/utils/logAnalytics";
type MoveType = Parameters<typeof api.page.moveTo>[1];
type PickerCallback = NonNullable<Parameters<typeof openCategoriesPicker>[0]["callback"]>;
type PickerCallbackData = Parameters<PickerCallback>[0];

const toHandle = (data: PickerCallbackData): { id: string; type: MoveType } => {
  const { type, id, rootId } = data;
  // 移动到团队空间
  if (!id) {
    return {
      type: "folder",
      id: "root"
    };
  }
  if (type === 12) {
    // 移动到空间分类
    if (rootId !== id) {
      return {
        type: "folder",
        id: id
      };
    }
    // 移动到空间根目录
    if (rootId === id) {
      return {
        type: "folder",
        id: rootId
      };
    }
  }
  // 移动到我的空间
  if (id) {
    return {
      type: "folder",
      id: id
    };
  }
  // 默认移动到我的空间根目录
  return {
    type: "folder",
    id: "root"
  };
};

// eslint-disable-next-line max-params
const Move: IPageAddCallback = (props, isAllow, isTeam, globalContext) => {
  const { data, remove, gname = "", reload, name = "", setData, originId = "" } = props;
  const defaultNav = gname
    ? [
        {
          name: gname,
          id: data?.space_id,
          icon: "iconapp_btn_folder",
          level: 1,
          isLeaf: false,
          type: 3,
          disabled: false,
          selectable: true
        }
      ]
    : null;
  const callback: PickerCallback = async (o, close) => {
    // const spaceId = o?.space?.id;
    // if (spaceId) {
    //     const perm = await getPermissions(spaceId, 'space');
    //     if (!perm.PAGE_CREATE) {
    //         message.error(lang('ctx.move.perm.error'));
    //         return;
    //     }
    // }
    console.log(o, "lalal111");
    const tip = moveTips(props.data, o, isTeam);
    Modal.confirm({
      // @ts-ignore
      content: lang(tip, { name: o.name }),
      title: lang("ctx.move.tips.title"),
      cancelText: lang("common.cancel"),
      okText: lang("common.confirm"),
      onOk: () => {
        if (!o.id) {
          console.warn("notSelect");
          return;
        }
        const to = toHandle(o);
        // const toId = o.id === "root" ? "" : o.id;
        const useBatchMoveToDtoList = {
          batchMoveInfos: [
            {
              fromType:
                data.spaceType === folderTypeEnum.SHARE || data.spaceType === folderTypeEnum.GROUP
                  ? folderTypeEnum.SHARE
                  : folderTypeEnum.MY,
              targetId: data.id,
              targetType: 1
            }
          ],
          toId: to.id,
          toType: o.type === 3 ? 12 : o.type
        };
        const logId = getPageMenuLogId("doMove");
        console.log(
          logId,
          data.spaceType?.toString() || "",
          o.type?.toString() || "",
          "1",
          "click"
        );
        analysisLog(
          "xtbg_jzb_joyspace_home_1676548210761",
          logId,
          data.spaceType?.toString() || "",
          o.type?.toString() || "",
          "1",
          "click"
        );
        api.batch.moveTo(useBatchMoveToDtoList as any).then((data1) => {
          if (data1?.data) {
            message.success(data1?.data || lang("common.success"));

            const res = getSpaceIdByRootId(originId, o.id);
            if (!res) {
              setData({
                type: ActionFnEnum.REMOVE,
                id: props.data.id,
                actionType: ActionType.Page
              } as any);
            }
            events.emit("list.check");
          } else {
            message.error(data1?.status || lang("common.fail"));
          }
          close();
        });
      }
    });
  };
  return [
    {
      children: lang("ctx.move.title"),
      callbackOrModal: () => {
        openCategoriesPicker({
          title: data.title || data.name || "无标题",
          selectArray: [
            {
              id: props.data.id,
              rootId: props.data.space_id,
              type: "file"
            }
          ],
          isTeam: isTeam,
          originId,
          // type: 'all',
          appRuntimeEnv: globalContext?.appRuntimeEnv,
          // 过滤掉当前类目
          // categoriesInterceptor: (categories) =>
          //     categories.filter((category) => category.id !== data.space_category_id),
          callback,
          defaultNav,
          reload,
          from: name,
          isGroupSpace: gname ? true : false
        });
      },
      isAllow,
      type: "move",
      icon: "pc_yundoc_move",
      splitCode: 2,
      tip: "将文档或文件夹移动到新的位置。仅文档和文件夹的所有者或可管理协作者可移动。"
    }
  ];
};

export default Move;
